import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'child-cell',
  template: `
  <span>
      <i class="fa fa-file text-primary" *ngIf="params.data.attachment || params.data.in_attachment || params.data.out_attachment" (click)="invokeParentMethod()"></i>
    </span>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
        // margin-bottom: 5px;
      }
    `,
  ],
})
export class ImageRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.params.data['action'] = 'image';
    this.params.context.componentParent.methodFromParent(
        this.params.data
    );
    console.log(this.params.data)
  }

  refresh(): boolean {
    return false;
  }
}